module.exports = __webpack_public_path__ + "static/img/attestation1.d73ebed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/attestation1.png
// module id = SADJ
// module chunks = 2